module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps__wrapper"
  }, [_c('span', {
    staticClass: "active-step"
  }, [_vm._v(_vm._s(_vm.activeStep))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('OF_2')) + " " + _vm._s(_vm.steps))]), _vm._v(" "), _c('div', {
    staticClass: "steps hidden-xs-only"
  }, _vm._l((_vm.steps), function(index, step) {
    return _c('div', {
      key: index,
      staticClass: "step-dot",
      class: {
        'step-dot--active': _vm.isActiveStep(index)
      }
    }, [_c('div', {
      staticClass: "dot",
      class: {
        last: _vm.isLastStep(index)
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35eb9a33","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/steps.vue
// module id = 1183
// module chunks = 0